'use strict';

import passwordTemplate from './password.html';

import Password from './password.ctrl';

function passwordRouter($stateProvider) {
  $stateProvider
    .state('password', {
      url: '/password?:email&:orgId&:orgName&:userId',
      template: passwordTemplate,
      controller: 'PasswordController as vm',
      resolve: {
        checkTranslationFilesLoaded: (I18nService) => {
          return I18nService.ensureLoaded();
        }
      }
    });
}

export default angular
  .module('password.router', [
    Password
  ])
  .config(passwordRouter)
  .name;
